export default __webpack_public_path__ + "static/media/NotoSans-Bold.2ae35399.otf";